var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"my-5"},[_c('a',{attrs:{"href":"https://www.amnistie.ca"}},[_c('v-img',{staticClass:"header-logo",attrs:{"src":require("@/assets/img/logo-black.png"),"height":"80","width":"76"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }